import keyMirror from './keyMirror';

export const fbPixelStandardEvents = keyMirror(
  'AddPaymentInfo',
  'AddToCart',
  'AddToWishlist',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'InitiateCheckout',
  'Lead',
  'PageView',
  'Purchase',
  'Schedule',
  'Search',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
  'ViewContent',
);

export const fbPixelCustomEvents = keyMirror(
  'SignIn',
  'SignUpWithFacebook',
  'SignUpWithGoogle',
  'SignUpWithApple',
  'SignUpPageVisit',
  'SignInPageVisit',
  'PaymentPageVisit',
  'RenewSubscription',
  'OptInComplete',
  'StartPlay',
);

export function fbTrack(evtName, details) {
  if (!window) return false;

  const trackType = fbPixelStandardEvents[evtName] ? 'track' : 'trackCustom';
  window.fbq(trackType, evtName, details);

  return true;
}

export function fbTrackSignIn() {
  fbTrack(fbPixelCustomEvents.SignIn);
}

export function fbTrackPageView(path) {
  fbTrack(`PageView_${path}`);
}

export function fbTrackOauthLogin(isSignIn, isSignUp, eventName) {
  if (isSignUp) {
    fbTrack(eventName);
  } else {
    if (isSignIn) {
      fbTrackSignIn();
    }
  }
  return true;
}
